// extracted by mini-css-extract-plugin
export default {"rightIcon":"RightSlider_rightIcon__C67CD","logoBorder":"RightSlider_logoBorder__zzThL"};